import { Box, Flex, Stack } from '@chakra-ui/react';
import LeftArrow from '@components/icons/LeftArrow';
import Button from '@components/interactive/Button';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { antlerStyle } from '@constants/styles';

const VideoResource = ({ title, buttonLabel, href, videoURL }) => {
  return (
    <Stack px={antlerStyle.px} w="100%" mx="auto" align="center" py={24} spacing={12}>
      <Flex alignItems="center" gap={6}>
        <LeftArrow href={Routes.dashboard} />
        <Header as="h1">{title}</Header>
      </Flex>
      <Box h={['240px', '400px']} w="100%" maxW="700px">
        <iframe title={title} width="100%" height="100%" src={videoURL} allowFullScreen />
      </Box>
      <Button href={href}>{buttonLabel}</Button>
    </Stack>
  );
};

export default VideoResource;
